import React, { useState } from "react";
import "./ContactForm.css";

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus("");

    // Simulate form submission
    // Replace with actual email service (EmailJS, Formspree, etc.)
    try {
      await new Promise((resolve) => setTimeout(resolve, 1500));

      // For demo purposes - in production, send to email service
      console.log("Form submitted:", formData);

      setStatus("success");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      setStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-form-container">
      <h3 className="form-title">Отправить сообщение</h3>
      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-row">
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Ваше имя"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <span className="input-highlight"></span>
          </div>
          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <span className="input-highlight"></span>
          </div>
        </div>
        <div className="form-group">
          <input
            type="text"
            name="subject"
            placeholder="Тема"
            value={formData.subject}
            onChange={handleChange}
            required
          />
          <span className="input-highlight"></span>
        </div>
        <div className="form-group">
          <textarea
            name="message"
            placeholder="Ваше сообщение..."
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <span className="input-highlight"></span>
        </div>
        <button
          type="submit"
          className={`submit-btn ${isSubmitting ? "loading" : ""}`}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <span className="loader-spinner"></span>
          ) : (
            <>
              <span>Отправить</span>
              <svg
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="currentColor"
              >
                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
              </svg>
            </>
          )}
        </button>
        {status === "success" && (
          <div className="form-status success">
            ✓ Сообщение успешно отправлено!
          </div>
        )}
        {status === "error" && (
          <div className="form-status error">
            ✗ Ошибка при отправке. Попробуйте снова.
          </div>
        )}
      </form>
    </div>
  );
}

export default ContactForm;
